module.exports = __webpack_public_path__ + "static/media/first-finance.703801fb.png";